// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import { Render } from '@puckeditor/core';
import '@puckeditor/core/puck.css';
import { func } from 'prop-types';

import { puckConfig } from 'Lib/puck.config';
import useFetch from 'Hooks/useFetch';
import useRouter from 'Hooks/useRouter';
import useAsyncError from 'Hooks/useAsyncError';
import { API_PAGES } from 'Constants';

const PromotionTemplate = ({ onTemplateTitleChange }) => {
  const fetcher = useFetch();
  const throwError = useAsyncError();
  const { params } = useRouter();
  const [template, setTemplate] = useState(null);

  useEffect(() => {
    if (!params.id) return;

    const fetchTemplate = async () => {
      try {
        const page = await fetcher(`${ API_PAGES }/${ params.id }`);
        setTemplate(page);
        const nextTitle = page?.Title || page?.title || '';
        onTemplateTitleChange(nextTitle);
      } catch (error) {
        throwError(error);
      }
    };
    fetchTemplate();
  }, [fetcher, params.id, throwError, onTemplateTitleChange]);

  if (!template) {
    return null;
  }

  return (
    <Render config={ puckConfig } data={ template?.data || {} } />
  );
};

PromotionTemplate.displayName = 'PromotionTemplate';

PromotionTemplate.propTypes = {
  onTemplateTitleChange: func,
};

PromotionTemplate.defaultProps = {
  onTemplateTitleChange: () => null,
};

export default PromotionTemplate;
